import React from "react";

import { Box } from "@material-ui/core";

import KPIFact from "components/visuals/KPIFact";

import {
    selectClickAndCollectTypicalYearRevenuePrediction,
    selectPredictionIsLoading,
    selectPredictionHasErrors,
    selectTypicalYearRevenuePrediction
} from "modules/customer/tools/location/overview/overviewSlice";
import { useAppSelector } from "store";
import numberFormatter from "utils/numberFormatter";

const TotalYearlyRevenuePrediction: React.FC = () => {
    const predictionIsLoading = useAppSelector(selectPredictionIsLoading);
    const predictionHasErrors = useAppSelector(selectPredictionHasErrors);
    const typicalYearRevenuePrediction = useAppSelector(selectTypicalYearRevenuePrediction);
    const clickAndCollectTypicalYearRevenuePrediction = useAppSelector(selectClickAndCollectTypicalYearRevenuePrediction);
    const value = typicalYearRevenuePrediction + clickAndCollectTypicalYearRevenuePrediction;
    const valueFormatted = numberFormatter.toGBP(value, 1);
    const label = "Pinned location total yearly revenue prediction";

    return (
        <Box width="100%" height="100%" data-cy="total-year-revenue-prediction">
            <KPIFact loading={predictionIsLoading} error={predictionHasErrors} label={label} value={valueFormatted} />
        </Box>
    );
};

export default TotalYearlyRevenuePrediction;
